import type { MouseEvent } from 'react';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@reflex/ui/components/ui/hover-card';
import { RESOURCE_PREVIEW_HOVER_CONTENT_CLASS } from '@reflex/ui/components/resource-preview/ResourcePreviewCard';
import { UserAvatar } from '@/components/shared/UserAvatar';
import { UserPreview } from '@/components/resource-preview/UserPreview';
import { useUsers } from '@/hooks/auth/useUsers';

interface AgentOwnerAvatarProps {
  userId: string;
}

export function AgentOwnerAvatar({ userId }: AgentOwnerAvatarProps) {
  const { data: users } = useUsers();
  const user = users?.find((u) => u.id === userId);
  const displayName = user?.name ?? user?.login ?? null;

  function stopRowSelect(event: MouseEvent<HTMLSpanElement>) {
    event.stopPropagation();
  }

  return (
    <HoverCard openDelay={150} closeDelay={100}>
      <HoverCardTrigger asChild>
        <span
          data-testid={`agent-owner-avatar-${userId}`}
          // `img`: a bare span may not carry `aria-label`
          // (axe `aria-prohibited-attr`); the avatar is a glyph.
          role="img"
          aria-label={displayName ? `Owned by ${displayName}` : 'Owned by another user'}
          className="inline-flex shrink-0 cursor-default"
          onClick={stopRowSelect}
        >
          <UserAvatar
            userName={displayName ?? undefined}
            avatarUrl={user?.avatarUrl ?? undefined}
            size="xs"
          />
        </span>
      </HoverCardTrigger>
      <HoverCardContent align="end" className={RESOURCE_PREVIEW_HOVER_CONTENT_CLASS}>
        <UserPreview id={userId} />
      </HoverCardContent>
    </HoverCard>
  );
}
